import { render, staticRenderFns } from "./order_pj.vue?vue&type=template&id=a9bacbbe&scoped=true"
import script from "./order_pj.vue?vue&type=script&lang=js"
export * from "./order_pj.vue?vue&type=script&lang=js"
import style0 from "./order_pj.vue?vue&type=style&index=0&id=a9bacbbe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bacbbe",
  null
  
)

export default component.exports